import styled from 'astroturf/react';

const TopBarMenu = styled('div')`
  &.horizontal {
    width: calc(100vw - 132px);
    margin-left: 67px;
    display: flex;
    height: 57px;
    align-items: center;
    justify-content: space-between;
    margin-top: 1px;

    &.expanded {
      width: calc(100vw - 270px);
      margin-left: 221px;
    }
  }
`;

const PlatformGroup = styled('div')`
  display: flex;
`;

const PlatformButton = styled('div')`
  display: flex;
  cursor: pointer;
  width: 100px;
  height: 23px;
  border-radius: 30px;
  background-color: white;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  padding-top: 4px;

  &.expanded.right-btn {
    margin-right: 6px;
  }

  &.right-btn {
    margin-right: 9px;
  }

  svg {
    width: 100px;
  }

  &:hover {
    outline: 3px solid var(--white);
  }
`;

const MenuContainer = styled('div')`
  margin-top: 11px;
  display: flex;
  position: relative;
  gap: 15px;
  margin-right: -10px;

  &.expanded {
    margin-right: 6px;
  }
`;

export default {
  TopBarMenu,
  PlatformGroup,
  MenuContainer,
  PlatformButton
};
